import { ArchIcon } from "@/components/icons";
import { Eyebrow } from "@/components/Eyebrow";
import { SectionHeader } from "@/components/SectionHeader";
import propertyNewBuild from "@/assets/property-new-build.webp?w=480;720;986&format=webp&as=meta";
import propertyRetrofit from "@/assets/property-retrofit.webp?w=480;720;1008&format=webp&as=meta";
import { responsiveImage } from "@/lib/responsiveImage";

const CASES = [
  {
    eyebrow: "New construction",
    title: "Integrated from the start",
    points: [
      "Lower wiring and installation requirements",
      "Simplified setup and maintenance",
      "Reduced room downtime",
    ],
    image: responsiveImage(propertyNewBuild),
    alt: "Somo keypad and thermostat specified into a new guest room",
  },
  {
    eyebrow: "Retrofit & Renovations",
    title: "Upgrade without starting over",
    points: [
      "Flexible installation",
      "No need to open walls",
      "Full lighting scene control without rewiring",
    ],
    image: responsiveImage(propertyRetrofit),
    alt: "Somo controls fitted into an existing guest room",
  },
];

export function PropertyFitSection() {
  return (
    <section className="relative section-panel px-4 py-20 md:px-6 md:pb-32 md:pt-24">
      <div className="mx-auto flex max-w-6xl flex-col gap-12 md:gap-16">
        <SectionHeader
          variant="centered"
          className="px-4 md:px-0"
          icon={<ArchIcon className="size-10 text-brand" />}
          title="Somo Is Made for Your Property"
          body="Build Somo into your plans with streamlined wiring, simpler installation, and compatibility with leading hotel systems. Or bring Somo to existing properties with minimal rewiring or disruption, making it easier to modernize every room."
        />
        <ul className="grid gap-4 md:grid-cols-2">
          {CASES.map((item) => (
            <li
              key={item.eyebrow}
              className="flex h-120 flex-col gap-4 rounded-card bg-primary p-4 md:h-auto md:items-center md:gap-10 md:px-8 md:pb-8 md:pt-10 md:text-center"
            >
              <div className="flex flex-col gap-4 px-4 pt-4 md:p-0">
                <Eyebrow>{item.eyebrow}</Eyebrow>
                <h3 className="text-balance text-lg leading-title text-primary md:text-2xl md:leading-normal">
                  {item.title}
                </h3>
                <ul className="text-sm leading-normal tracking-body text-secondary md:leading-loose">
                  {item.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </div>
              <img
                loading="lazy"
                decoding="async"
                {...item.image}
                sizes="(min-width: 768px) min(50vw, 504px), 100vw"
                alt={item.alt}
                className="min-h-0 w-full flex-1 object-cover md:aspect-square md:flex-none md:object-contain"
              />
            </li>
          ))}
        </ul>
      </div>
      {/* Runs across the section's bottom edge into the next section. */}
      <span
        aria-hidden
        className="absolute -bottom-24 left-1/2 z-10 h-48 w-px bg-gradient-to-b from-secondary via-line-strong to-primary"
      />
    </section>
  );
}
